import { store } from "../store/index";
import {
  setLanguage,
  getLoginItem,
  getAllCompanies,
  setDataLine,
  setFilterPart,
  setFilterPartDes,
  setFilterCode,
  setFilterTask,
  setFilterViv,
  setFilterVariety,
  setFilterBatch,
  setFilterArticle,
  setFilterLocation,
  setFilterSect,
  setFilterUser,
  setFilterProvider,
} from "../store/actions/GeneralActions";
import { setAuthUser, setAuthToken } from "../store/actions/AuthActions";
import {
  SET_FILTER_PART,
  SET_FILTER_PART_DES,
  SET_FILTER_CODE,
  SET_FILTER_TASK,
  SET_FILTER_VIV,
  SET_FILTER_VARIETY,
  SET_FILTER_BATCH,
  SET_FILTER_ARTICLE,
  SET_FILTER_LOCATION,
  SET_FILTER_SECT,
  SET_FILTER_USER,
  SET_FILTER_PROVIDER,
} from "../constants";

/**
 * Set setPreferredLanguage language
 */
export const setPreferredLanguage = async (obj) => {
  store.dispatch(setLanguage(obj));
};

/**
 * Get item
 */
export const getItemLoginTemp = async (token) => {
  let result = await store.dispatch(getLoginItem(token));
  if (result?.payload?.access_token) {
    await store.dispatch(setAuthUser(result.payload.user));
    await store.dispatch(
      setAuthToken({
        access_token: result.payload.access_token,
        token_expiration: result.payload.token_expiration,
      }),
    );
    return "OK";
  }
  return null;
};

/**
 * Set line
 */
export const setLine = async (obj) => {
  store.dispatch(setDataLine(obj));
};

/**
 * Set filter
 */
export const setFilter = async (filter, type) => {
  switch (type) {
    case SET_FILTER_PART:
      store.dispatch(setFilterPart(filter));
      break;

    case SET_FILTER_PART_DES:
      store.dispatch(setFilterPartDes(filter));
      break;

    case SET_FILTER_CODE:
      store.dispatch(setFilterCode(filter));
      break;

    case SET_FILTER_TASK:
      store.dispatch(setFilterTask(filter));
      break;

    case SET_FILTER_VIV:
      store.dispatch(setFilterViv(filter));
      break;
    case SET_FILTER_VARIETY:
      store.dispatch(setFilterVariety(filter));
      break;

    case SET_FILTER_BATCH:
      store.dispatch(setFilterBatch(filter));
      break;
    case SET_FILTER_ARTICLE:
      store.dispatch(setFilterArticle(filter));
      break;
    case SET_FILTER_LOCATION:
      store.dispatch(setFilterLocation(filter));
      break;
    case SET_FILTER_SECT:
      store.dispatch(setFilterSect(filter));
      break;
    case SET_FILTER_USER:
      store.dispatch(setFilterUser(filter));
      break;
    case SET_FILTER_PROVIDER:
      store.dispatch(setFilterProvider(filter));
      break;

    default:
      break;
  }
};
